import { useEffect, useState } from 'react';
import { envoisApi } from '../api/resources';

/**
 * La boîte e-mail de l'entreprise (info@bektech.ch), lue une fois par
 * session : les boutons « E-mail » qui ouvraient l'application Mail du
 * téléphone font partir le message par SwissTech quand elle est raccordée.
 */
let promesse = null;

/**
 * @returns {Promise<object|null>} la boîte raccordée, ou null
 */
export function boiteEntreprise() {
  if (!promesse) {
    promesse = Promise.resolve()
      .then(() => envoisApi.boite())
      .then((b) => (b?.raccordee ? b : null))
      .catch(() => null);
  }
  return promesse;
}

/** À appeler quand la boîte est raccordée ou débranchée. */
export function oublieBoite() {
  promesse = null;
}

/**
 * @returns {object|null} la boîte raccordée, ou null (aussi pendant la lecture)
 */
export function useBoiteEntreprise() {
  const [boite, setBoite] = useState(null);
  useEffect(() => {
    let vivant = true;
    boiteEntreprise().then((b) => {
      if (vivant) setBoite(b);
    });
    return () => {
      vivant = false;
    };
  }, []);
  return boite;
}
